module.exports = __webpack_public_path__ + "assets/img/line.15b27f5b.png";